import { useEffect } from 'react';

export const useFavicon = () => {
  useEffect(() => {
    const fetchAndSetFavicon = async () => {
      try {
        const response = await fetch('/api/admin/favicon-url');
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.faviconUrl) {
            updateFavicon(data.faviconUrl);
          }
        }
      } catch (error) {
        console.error('Failed to fetch favicon:', error);
      }
    };

    fetchAndSetFavicon();
  }, []);

  const updateFavicon = (faviconUrl: string) => {
    // Remove existing favicon links
    const existingLinks = document.querySelectorAll('link[rel*="icon"]');
    existingLinks.forEach(link => link.remove());

    // Create new favicon link
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
  };

  return { updateFavicon };
}; 